import { trpc } from "../lib/trpc.js";

/** Returns a stable callback suitable for CommandPalette onSearch prop. */
export function useGlobalSearch() {
  const utils = trpc.useUtils();
  return (q: string) => utils.v1.gtm.globalSearch.fetch({ q });
}

/** Returns a stable callback suitable for ActivityDrawer onFetchActivity prop. */
export function useActivityFeed() {
  const utils = trpc.useUtils();
  return (filter: "all" | "mine" = "all") =>
    utils.v1.gtm.getActivityFeed.fetch({ filter, limit: 50 });
}
